import { Injectable } from '@angular/core';
import { EquipmentMaintenanceMapped } from '@core/interfaces';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class UpdatedByService {
  private readonly customAuthorDeviceMapper = Object.freeze({
    mountdoom: 'laptop',
    lorgan: 'upload',
    gorgoroth: 'smartphone',
    system: 'settings'
  });

  constructor(private translateService: TranslateService) {}

  public customUpdatedByIn(equipmentMaintenances: EquipmentMaintenanceMapped[]): EquipmentMaintenanceMapped[] {
    for (let equipmentMaintenance of equipmentMaintenances) {
      equipmentMaintenance = this.generateUpdateBy(equipmentMaintenance);
    }

    return equipmentMaintenances;
  }

  private generateUpdateBy(equipmentMaintenance: EquipmentMaintenanceMapped): EquipmentMaintenanceMapped {
    const equipmentMaintenanceLog = equipmentMaintenance.log || {};

    const logCustomAuthor = {
      type: this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.AUTHOR.CREATED'),
      updatedByName: null,
      clientApplicationName: this.translateService.instant(`MAINTENANCES.TABS.LOGS.PLATFORMS.${String(equipmentMaintenanceLog.clientApplicationName || 'BROWSER').toUpperCase()}`)
    };

    if (equipmentMaintenanceLog.updatedBy && equipmentMaintenanceLog.updatedBy.name) {
      logCustomAuthor.updatedByName = this.translateService.instant(
        'EQUIPMENTS.DIALOG.HISTORIC.AUTHOR.BY_AUTHOR',
        {
          authorName: equipmentMaintenanceLog.updatedBy.name
        }
      );
    }

    if (equipmentMaintenanceLog.clientApplicationName) {
      logCustomAuthor.clientApplicationName = this.translateService.instant(
        `EQUIPMENTS.DIALOG.HISTORIC.AUTHOR.DEVICES.${String(equipmentMaintenanceLog.clientApplicationName).toUpperCase()}`
      );
    }

    if (Object.values(logCustomAuthor).filter(Boolean).length >= 2) {
      equipmentMaintenance.customAuthorDevice = this.customAuthorDeviceMapper[
        equipmentMaintenanceLog.clientApplicationName
      ];
      equipmentMaintenance.customAuthor = Object.values(logCustomAuthor).filter(Boolean).join(' ');
    }

    return equipmentMaintenance;
  }
}
